import React, { useState } from "react";

function TableHead(props) {
  const [activeColumnNumber, setActiveColumnNumber] = useState(0);
  const tabAll = props.tabItems.map((item, index) => (
    <div
      id={item.id}
      key={index}
      title={item.textFull}
      className={index === activeColumnNumber ? "active" : ""}
      onClick={() => {
        let rev = props.sort.reverse;
        if (props.sort.by === item.dataItem) rev = !props.sort.reverse;
        props.setSort({
          reverse: rev,
          by: item.dataItem,
        });
        setActiveColumnNumber(index);
      }}
    >
      {item.textLong}{ props.sort.reverse ?  String.fromCharCode(9652) : String.fromCharCode(9662)}
    </div>
  ));

  return <div className="tableHead" onClick={()=> {props.setIdOpt(null)}}>{tabAll}</div>;

  /*(
    <div className="tableHead">
        <div id="id">Nr</div>
        <div id="doctype">Rodzaj dok. sprzed.</div>
        <div id="docnumber">Nr dok. sprzed.</div>
        <div id="problemorerror">Problem / błąd pracownika</div>
        <div id="employeeinvolved">Pracownik związany z błędem lub problemem</div>
        <div id="description">Dokładny opis sytuacji</div>
        <div id="datereportedbymanager">Zgłoszony przez kier. rec. do KJ @ dnia:</div>
        <div id="approvedsolution">Rozwiązanie zatw. przez KJ</div>
        <div id="datedone">Zrealizowano dnia przez kier. rec.</div>                       
    </div>
    )*/
}

export default TableHead;
